import { useCallback, useMemo } from 'react';
import { useUser } from '../../components/userManagement/hooks';
import { formatUserDateTime, formatUserDate, formatUserTime } from '../utils';

export const useUserDateFormatter = () => {
  const { data: me } = useUser('me');
  const prefs = useMemo(
    () => ({
      dateFormat: me?.dateFormat,
      is24HourFormat: me?.is24HourFormat,
      zoneInfo: me?.zoneInfo,
    }),
    [me?.dateFormat, me?.is24HourFormat, me?.zoneInfo],
  );

  const pickerFormat = useMemo(() => {
    const dateFormat = prefs.dateFormat ?? 'MM/dd/yyyy';
    const timeFormat = prefs.is24HourFormat ? 'HH:mm' : 'hh:mm aa';
    return `${dateFormat} ${timeFormat}`;
  }, [prefs.dateFormat, prefs.is24HourFormat]);

  const formatDateTime = useCallback(
    (dateIso?: string | null) => formatUserDateTime(dateIso, prefs),
    [prefs],
  );
  const formatDate = useCallback(
    (dateIso?: string | null) => formatUserDate(dateIso, prefs),
    [prefs],
  );
  const formatTime = useCallback(
    (dateIso?: string | null) => formatUserTime(dateIso, prefs),
    [prefs],
  );

  return {
    formatDateTime,
    formatDate,
    formatTime,
    pickerFormat,
    is24HourFormat: prefs.is24HourFormat ?? false,
  };
};
